import { type Asset, type AssetMetadata } from '@/siteview/entities/asset';
import type { DeepUnknown } from '@/types/deep-unknown';

export function assetFromApi(data: any): DeepUnknown<Asset> {
  if (!data) return undefined;

  return {
    id: data?.accure_id,
    type: data?.battery_level,
    alertStatus: data?.alert_status,
    frontendId: data?.frontend_unit_id,
    fullFrontendId: data?.full_frontend_id,
    accureSoc: data?.accure_soc,
    bmsSoc: data?.bms_soc,
    imbalanceSoc: data?.imbalance_soc,
    temperature: data?.temperature,
    throughput: data?.throughput,
    nbOpenTasks: data?.nb_open_tasks,
    metadata: assetMetadataFromApi(data),
  };
}

export function assetMetadataFromApi(data: any): DeepUnknown<AssetMetadata> {
  if (!data) return undefined;

  return {
    capacity: data?.capacity,
    cellType: data?.cell_type,
    manufacturer: data?.manufacturer,
    cellChemistry: data?.cell_chemistry,
    deviceType: data?.device_type,
  };
}
